import React from 'react';
import { View, Text, TextInput, ViewStyle, TextInputProps } from 'react-native';
import styles from './Search.styles';
import Icon from '../../Icon/Icon';
import theme from '../../../common/theme';

interface Props extends TextInputProps {
  title?: string;
  testID: string;
  placeholder?: string;
  value?: string | undefined;
  containerStyle?: ViewStyle | ViewStyle[];
}

const Search: React.FC<Props> = ({
  title,
  testID,
  placeholder,
  value,
  containerStyle,
  ...props
}) => {
  return (
    <View style={containerStyle}>
      {!!title && <Text style={styles.inputTitleText}>{title}</Text>}
      <TextInput
        value={value}
        testID={testID}
        placeholder={placeholder}
        placeholderTextColor={theme.palette.mono500}
        style={styles.inputContainer}
        autoCorrect={false}
        {...props}
      />
      <View accessibilityRole="none" style={styles.accessory}>
        <Icon name="search" color={theme.palette.mono500} />
      </View>
    </View>
  );
};

export default Search;
